// TODO: Implementar Terapia Ocupacional
export const TerapiaOcupacional = () => <></>;
